import { render, staticRenderFns } from "./table_next_checkpoint.vue?vue&type=template&id=22a52f18&scoped=true&"
import script from "./table_next_checkpoint.vue?vue&type=script&lang=js&"
export * from "./table_next_checkpoint.vue?vue&type=script&lang=js&"
import style0 from "./table_next_checkpoint.vue?vue&type=style&index=0&id=22a52f18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a52f18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
